const ALLOWED_RETURN_URL = /^https?:\/\/([\w-]+\.)?carpenters\.org(\/|$)/;

/**
 * Returns the ReturnUrl query parameter if it points to a trusted carpenters.org
 * domain, or null if absent/untrusted (guards against open-redirect attacks).
 *
 * @param {import('vue-router').Route} route
 * @returns {string|null}
 */
export function getSafeReturnUrl(route) {
  const url = route?.query?.ReturnUrl;
  if (url && ALLOWED_RETURN_URL.test(url)) {
    return url;
  }
  return null;
}
